import { FC } from 'react';
import { Card, HStack, Icon, Text } from '@wegroup/design-system';
import TableCheckbox from '@parties/src/features/overview/components/table/TableCheckbox';
import { useFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/flowsConfigureStore';
import { AnvaFlowsInsuranceTag } from '@flows/src/api/anva-flows/getAnvaFlowsInsuranceTags';

interface Props {
  insuranceGroup: AnvaFlowsInsuranceTag;
  isError?: boolean;
  clearError?: () => void;
}

const FlowsConfigureInsuranceGroupItem: FC<Props> = ({
  insuranceGroup,
  isError,
  clearError,
}) => {
  const setInsurances = useFlowsConfigureStore((state) => state.setInsurances);
  const isSelected = useFlowsConfigureStore((state) =>
    state.insurances.some(({ id }) => id === insuranceGroup.id),
  );

  const handleSelect = () => {
    const updatedInsurances = isSelected
      ? useFlowsConfigureStore
          .getState()
          .insurances.filter((item) => item.id !== insuranceGroup.id)
      : [...useFlowsConfigureStore.getState().insurances, insuranceGroup];
    if (isError) clearError?.();
    setInsurances(updatedInsurances);
  };

  return (
    <Card
      as="button"
      p="4"
      borderColor={
        isError ? 'danger.main' : isSelected ? 'primary.500' : 'gray.50'
      }
      h="100%"
      onClick={() => handleSelect()}
      _hover={{
        borderColor: isSelected ? undefined : 'gray.100',
        boxShadow: isError ? undefined : 'level2',
      }}
      cursor="pointer"
      transition="0.1s"
    >
      <HStack spacing="3">
        {insuranceGroup.icon_key && (
          <Icon name={insuranceGroup.icon_key} color="primary.500" />
        )}
        <Text flexGrow="1">{insuranceGroup.name}</Text>
        <TableCheckbox isChecked={isSelected} onChange={() => null} />
      </HStack>
    </Card>
  );
};

export default FlowsConfigureInsuranceGroupItem;
